import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'
import Counter from '../../../../../../../../../../components/Counter'

export default class Summary extends Component {
    static propTypes = {
        activeCompanies: PropTypes.number.isRequired,
        activeRoles: PropTypes.number.isRequired,
        translates: PropTypes.shape({
            activeCompaniesLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            activeRolesLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    render() {
        const {
            activeCompanies,
            activeRoles,
            translates: { activeCompaniesLabel, activeRolesLabel },
        } = this.props

        return (
            <div className={'summary-container'}>
                <div className="counter-wrapper">
                    <Counter
                        leftValue={{
                            value: activeCompanies,
                        }}
                        description={activeCompaniesLabel}
                    />
                </div>
                <div className="counter-wrapper">
                    <Counter
                        leftValue={{
                            value: activeRoles,
                        }}
                        description={activeRolesLabel}
                    />
                </div>
            </div>
        )
    }
}
